/**
 * WHAT: Menu Page Initialization Module
 * WHY: Handle menu page specific functionality
 * HOW: JavaScript module with proper imports and exports
 * IMPORTANCE: Separates concerns and follows industry standards
 */

// Import menu specific functionality
import { initializeMenu, checkNoImageExists, onMenuSearchInput } from './menu.js';

// Initialize menu page
async function initializeMenuPage() {
    try {
        console.log('Menu page initialized');
        
        // Check if no-image SVG exists before loading menu
        await checkNoImageExists();
        
        // Initialize the menu
        await initializeMenu();
        
        // Add search handler
        const searchInput = document.querySelector('.menu__search-input');
        if (searchInput) {
            searchInput.addEventListener('input', debounce(() => {
                onMenuSearchInput();
            }, 300));
        }
        
    } catch (error) {
        console.error('Error initializing menu page:', error);
    }
}

// Debounce utility function
function debounce(func, wait) {
    let timeout;
    return function executedFunction(...args) {
        const later = () => {
            clearTimeout(timeout);
            func(...args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    };
}

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', initializeMenuPage);

// Export for potential use in other modules
export { initializeMenuPage };
